module.exports = __webpack_public_path__ + "media/images/icon_btn_spaces-74bd7a6dd2b2e67070bee7ea76b74602.svg";